import React, { Component } from 'react';
import Usuario from '../../../Utils/Usuario';
// import { Permissions } from '../../../Utils/Permissions';
import ReactTable from 'react-table';
import { Modal, ModalBody, ModalHeader, ModalFooter, Button, UncontrolledTooltip } from "reactstrap";
import moment from 'moment';
import axios from 'axios';
// import './Special-Areas.scss';
import { Configurations } from '../../../Utils/Configurations';
import Session from '../../../Utils/Session';
import update from 'immutability-helper';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';
import ImagemFukyo from '../../../Components/Imagem-Fukyo/Imagem-Fukyo'

class AreasList extends Component {

    constructor(props) {
        super(props);

        this.confirmaStatusPublicacao = this.confirmaStatusPublicacao.bind(this);
        this.carregaAreas = this.carregaAreas.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.resetModalInfos = this.resetModalInfos.bind(this);
        this.refreshTableAreas = this.refreshTableAreas.bind(this);
        this.inicializaParametros = this.inicializaParametros.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.novaArea = this.novaArea.bind(this);
        this.toggleStatusPublicacao = this.toggleStatusPublicacao.bind(this);
        this.mudaStatusPrograma = this.mudaStatusPrograma.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.selecionaArea = this.selecionaArea.bind(this);

        this.state = {
            // isLoadingAreas: true,
            openModal: false,
            isLoadingStatusArea: false,
            modalStatusPublicacao: false,
            metodoStatusPublicacao: "habilitar",
            hasError: false,
            errorMessage: '',
        }

        this.columns = [
            {
                Header: '#',
                className: 'pointer',
                width: 40,
                Cell: row => <span>{row.index + 1}</span>
            },
            {
                Header: 'Capa',
                className: 'pointer',
                width: 100,
                Cell: row =>
                    <ImagemFukyo className="img img-capa-programa" src={row.original.saudacao.foto} alt={`capa-${row.original.nome.toLowerCase()}`} />
            },
            {
                Header: 'Nome',
                className: 'pointer text-left',
                accessor: 'nome',
                // width: 250,
            },
            {
                Header: 'Dt. publicação',
                accessor: 'dtPublicacao',
                className: 'text-center pointer',
                width: 120,
                Cell: row => (row.value ? <span>{moment(row.value).format("DD/MM/YY")}</span> : <span>erro</span>)
            },
            {
                Header: 'Status',
                className: 'text-center pointer',
                accessor: 'ativo',
                Cell: row => (<h6 className="m-0"><span className={`badge badge-${row.value ? 'success' : 'secondary badge-opacity'}`}>{row.value ? 'Habilitado' : 'Não habilitado'}</span></h6>),
                width: 100,
            },
            {
                Header: '',
                width: 80,
                className: 'text-center pointer',
                accessor: '_id',
                Cell: row => {
                    const _publicado = row.original.ativo,
                        _functionBtn = _publicado ? "desabilitar" : "habilitar",
                        _classIcon = _publicado ? `far fa-eye-slash` : `far fa-eye`,
                        _textTooltip = _publicado ? "desabilitar área" : "habilitar área";
                    return (
                        <div className="row no-gutters">
                            <div className="col-12 icones" id={`Tooltip-${row.original._id}`}>
                                {row.original.loading ? (
                                    <div className="spinner-border spinner-border-sm text-primary" role="status" />
                                ) : (
                                    <button onClick={() => this.confirmaStatusPublicacao(row.original, _functionBtn)}>
                                        <i className={`${_classIcon}`}></i>
                                    </button>
                                )}
                                <UncontrolledTooltip placement="top" target={`Tooltip-${row.original._id}`}>
                                    {_textTooltip}
                                </UncontrolledTooltip>
                            </div>
                        </div>
                    )
                }
            },
        ];

        this.Configurations = new Configurations();
    }

    componentWillMount() {
        // const _arrPerm = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        // const _paginas = _arrPerm.map(item => Permissions.pagesAccess(item)).flat();
        const _permissoes = [1, 4, 12, 14];
        const roles = Usuario.getLoggedUser.permissoes.map(item => item.numero);
        const found = roles.some(r => _permissoes.indexOf(r) >= 0);
        if (!found) this.props.history.push({ pathname: '/permissao-negada' })
        else {
            this.inicializaParametros(false);
        }
    }

    confirmaStatusPublicacao(area, metodo) {
        this.setState({
            nomeAreaStatusPublicacao: area.nome,
            idAreaStatusPublicacao: area._id,
            metodoStatusPublicacao: metodo
        }, () => this.toggleStatusPublicacao());

    }

    inicializaParametros() {
        // Session.clearInfosProgramas();
        const _parametros = [];
        _parametros.push(`qtdItens=${Session.getParametrosListaAreas.limite}`);
        _parametros.push(`pagina=${Session.getParametrosListaAreas.pagina}`);
        this.setState({
            queryParametros: _parametros,
            pagina: Session.getParametrosListaAreas.pagina,
            limite: Session.getParametrosListaAreas.limite,
        });
    }

    carregaAreas(o) {
        // this.setState({ isLoadingAreas: true })
        const _params = [];
        if (o === undefined) {
            _params.push(`qtdItens=${this.state.limite}`);
            _params.push(`pagina=${this.state.pagina + 1}`);
        }
        else if (!o.pageSize) {
            o.pageSize = this.state.limite;
            _params.push(`qtdItens=${o.pageSize}`);
        } else if (!(o.page + 1)) {
            o.page = this.state.pagina;
            _params.push(`pagina=${o.page + 1}`);
        } else {
            _params.push(`qtdItens=${o.pageSize}`);
            _params.push(`pagina=${o.page + 1}`);
            this.setState({
                pagina: o.page,
                limite: o.pageSize
            }, () => {
                Session.setParametrosListaAreas = { pagina: this.state.pagina, limite: this.state.limite };
            })
        }
        this.setState({
            queryParametros: _params,

        }, () => {
            const _areas = axios.get(this.Configurations.apiBasePath + `/areas-especiais?${this.state.queryParametros.join('&')}`);
            _areas.then(response => {
                this.setState({
                    listaAreas: response.data.areasEspeciais,
                    paginasAreas: response.data.paginacao.totalPaginas,
                });
            }).catch(this.handleError).finally(() => this.setState({ isLoadingAreas: false }));
        })
    }

    refreshTableAreas(o) {
        this.carregaAreas(o);
    }

    toggleModal() {
        this.setState({
            openModal: !this.state.openModal,
        }, () => {
            if (!this.state.openModal) {
                // this.carregaEdicoes();
                this.resetModalInfos();
            }
        })
    }

    resetModalInfos() { this.setState({ nomePrograma: '', descricaoPrograma: '', urlImagem: '' }) }

    novaArea() {
        this.props.history.push(`${this.props.match.url}/nova-area`)
    }

    handleOnChange(e) {
        e.preventDefault();
        const _name = e.target.name, _value = e.target.value;
        this.setState({ [_name]: _value })
    }


    toggleStatusPublicacao() {
        this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })
    }

    mudaStatusPrograma() {
        const _idArea = this.state.idAreaStatusPublicacao,
            _index = this.state.listaAreas.findIndex(item => item._id === _idArea);

        this.setState({ listaAreas: update(this.state.listaAreas, { [_index]: { loading: { $set: true } } }) })

        axios.put(this.Configurations.apiBasePath + `/areas-especiais/${_idArea}/toggle`).then(response => { }).catch(this.handleError).finally(() => {
            this.carregaAreas();
            this.toggleStatusPublicacao();
            this.setState({
                isLoadingEpisodios: false,
                listaAreas: update(this.state.listaAreas, { [_index]: { loading: { $set: false } } })
            })
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response.data.message })
    }
    closeErrorModal() { this.setState({ hasError: false, errorMessage: "" }) }


    selecionaArea(idArea) {
        this.props.history.push(`${this.props.match.url}/${idArea ? idArea : 'nova-area'}`)
    }

    render() {
        return (
            <div className="row programs-list">
                <div className="col-12">
                    <div className="row no-gutters align-items-center">
                        <div className="col-12 col-lg-8 text-center text-lg-left">
                            <h2 className="title-1 d-none d-lg-block">Lista de Áreas Especiais</h2>
                            <h2 className="d-lg-none">Lista de Áreas Especiais</h2>
                        </div>
                        <div className="col-12 col-lg-4 text-center text-lg-right">
                            <div className="row no-gutters">
                                <div className="col py-2 py-lg-0">
                                    <button className="btn btn-outline-info mx-2" type="button" name="novaEdicao" onClick={() => this.selecionaArea(null)}>
                                        Nova área especial
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.isLoadingAreas ? (
                    <div className="col-12 py-5 text-center">
                        <div className="spinner-border text-primary" role="status" />
                    </div>
                ) : (
                    <div className={`col-12 text-center text-lg-left`}>
                        <p className="py-2 m-0">Clique na área especial para obter mais detalhes e/ou fazer alterações.</p>
                        <div className="card">
                            <div className="card-body p-0">
                                <ReactTable
                                    data={this.state.listaAreas}
                                    columns={this.columns}
                                    onFetchData={this.refreshTableAreas}
                                    defaultPageSize={Session.getParametrosListaAreas.limite}
                                    pages={this.state.paginasAreas}
                                    page={this.state.pagina}
                                    pageSize={this.state.limite}
                                    manual
                                    loading={this.state.isLoadingAreas}
                                    className="-striped -highlight"
                                    headerClassName="ebs-table-header"
                                    previousText='Anterior'
                                    nextText='Próximo'
                                    loadingText='Carregando...'
                                    noDataText='Nenhuma área especial encontrada.'
                                    pageText='Página'
                                    ofText='de'
                                    rowsText='linhas'
                                    getTdProps={(state, rowInfo, column, instance) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                if (rowInfo) {
                                                    if (column.Header === "") handleOriginal();
                                                    else this.selecionaArea(rowInfo.original._id)
                                                }
                                            }
                                        }
                                    }}
                                />

                            </div>
                        </div>
                    </div>
                )}

                <Modal isOpen={this.state.modalStatusPublicacao} toggle={this.toggleStatusPublicacao}>
                    <ModalHeader toggle={this.toggleStatusPublicacao}>Mudança de Status da Área Especial</ModalHeader>
                    <ModalBody>
                        <p className="m-0">Deseja {this.state.metodoStatusPublicacao} a área especial <strong>{this.state.nomeAreaStatusPublicacao}</strong>?</p>
                    </ModalBody>
                    <ModalFooter>
                        {this.state.isLoadingStatusArea ? (
                            <div className="spinner-border text-primary" role="status" />
                        ) : (
                            <Button disabled={this.state.isLoadingStatusArea} color={`${this.state.metodoStatusPublicacao === 'habilitar' ? `success` : `danger`}`} onClick={this.mudaStatusPrograma}>confirmar</Button>
                        )}
                        {' '}<Button color="secondary" onClick={() => this.setState({ modalStatusPublicacao: !this.state.modalStatusPublicacao })}>voltar</Button>
                    </ModalFooter>
                </Modal>
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                // direcionaURL={'/conteudo'}
                // goBack={true}
                />
            </div>
        )
    }
}

export default AreasList;